const containerStack = {
  padding: { xs: '4rem 2rem 2rem 2rem', m: '5rem 2.5rem 2.5rem 2.5rem' },
  position: 'relative',
  alignSelf: 'stretch',
  gap: '3rem',
};

const videosStack = {
  flexDirection: { xs: 'column', md: 'row' },
  gap: '1.5rem',
};

const videosContainer = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
  padding: { xs: '0 1rem', m: '0 6rem', lg: '0 12rem' },
};

export { containerStack, videosStack, videosContainer };
